// @flow
import * as React from 'react';
import styled from 'styled-components';
import ShowModalContainer from 'containers/ShowModalContainer';
import ShareIcon from 'share.svg';
import { SecondaryButton } from 'components/Button';
import { colors, mediaRetina } from '../theme';

const StyledButton = styled(SecondaryButton)`
  display: inline-flex;
  align-items: center;
  &:hover {
    box-shadow: inset 0 0 0 1px ${colors.battleshipGrey};
    color: ${colors.battleshipGrey};
  }
  @media ${mediaRetina} {
    &:hover {
      box-shadow: inset 0 0 0 1.5px ${colors.battleshipGrey};
    }
  }
`;

const StyledShareIcon = styled(ShareIcon)`
  padding-right: 5px;
  ${/* sc-selector */ StyledButton}:hover & {
    &:not(:disabled) {
      color: ${colors.turtleGreen};
    }
  }
`;

const ShareListingButton = ({
  iconOnly,
  listing,
  listingType,
  // TODO(Karan): Remove the notion of listingSubType. It's only because IDEALIST_DAY_MAP
  // is inserted into LISTING_TYPE_HUMAN_NAME_MAP. It should not be.
  listingSubType,
  onClick,
  title,
  messageOverride,
  ...props
}: {
  iconOnly?: boolean,
  listing: { id: string },
  listingType: string,
  listingSubType?: string,
  onClick?: Function,
  title?: string,
  messageOverride?: string
}) => (
  <ShowModalContainer
    render={showModal => (
      <StyledButton
        aria-label="Share"
        onClick={e => {
          e.preventDefault();
          if (onClick) {
            onClick();
          }
          showModal('SHARE_LISTING', {
            listingType,
            listingSubType,
            listing,
            title,
            messageOverride
          });
        }}
        {...props}
      >
        <StyledShareIcon width="18" height="18" />
        {!iconOnly && getText('Share')}
      </StyledButton>
    )}
  />
);

export default ShareListingButton;
